let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hmyGT")).then(() => parcelRequire('8IIKL'));